/* eslint-disable no-restricted-imports */
import getTimezoneOffset from 'date-fns-tz/getTimezoneOffset';

import { addMinutes } from './modifyDate';
import { getDateFeatureConfig } from './DateConfigType';

/**
 * Converts the date to the UTC.
 * @param date date to convert
 * @return modified date
 */
export const convertToUtc = (date: Date): Date => {
    return addMinutes(date, date.getTimezoneOffset());
};

/**
 * If date without timezone offset (yyy-MM-dd) is received, appends current timezone from config to the string and returns it
 */
export function addDefaultTimezoneToUTCDate(date: Date): Date {
    const timezone = getDateFeatureConfig((f) => f?.base?.defaultTimezone);
    if (!timezone) {
        return date;
    }

    const offset = getTimezoneOffset(timezone, date);
    date.setTime(date.getTime() - offset);

    return date;
}

function getTimezoneDiff(date: Date): number {
    const timezone = getDateFeatureConfig((f) => f?.base?.defaultTimezone);
    if (!timezone) {
        return 0;
    }

    // eslint-disable-next-line @typescript-eslint/no-magic-numbers
    const currentOffset = date.getTimezoneOffset() * -1 * 60 * 1000;
    const offset = getTimezoneOffset(timezone);

    return offset - currentOffset;
}

/**
 * Shifts date with local (browser) timezone to bank timezone (default timezone)
 */
export function shiftDateToDefaultTimezone(dateWithCurrentTimezone: Date): Date {
    const offsetDiff = getTimezoneDiff(dateWithCurrentTimezone);

    dateWithCurrentTimezone.setTime(dateWithCurrentTimezone.getTime() - offsetDiff);
    return dateWithCurrentTimezone;
}
